<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Adicionar Obra"
    type-modal="add_project_modal"
  >
    <div class="modal-content__main">
      <project-form ref="projectForm"/>
    </div>

    <div slot="actions" class="modal-content__control" >
      <loader v-if="loading" :fullPage="false" class="mr-4"/>
      <d-button
        type="button"
        :disabled="loading"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ProjectForm from '_modules/project/components/ProjectForm.vue';
import ModalTemplate from '_shared/Modal.vue';

export default {
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Loader,
    ProjectForm,
    ModalTemplate,
  },
  methods: {
    save() {
      this.$refs.projectForm.submit();
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
  },
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
      max-width: 1100px;
  }
}
</style>
<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
